import HelpIcon from '@mui/icons-material/HelpOutline';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import objectPath from 'object-path';
import { useEffect, useMemo } from 'react';

import { QuickUserToggler } from '../../../_metronic/layout/components/extras/QuickUserToggler';
import { useHtmlClassService } from '../../../_metronic/layout/_core/MetronicLayout';
import { HELP_BAR_OPEN_CLASS } from '../HelpSidebar';

const useStyles = makeStyles((theme) => ({
  pulse: {
    animation: 'pulse-animation 2s infinite',
  },
  '@global': {
    '@keyframes pulse-animation': {
      '0%': {
        boxShadow: '0 0 0 0px rgba(0, 0, 0, 0.2)',
      },
      '100%': {
        boxShadow: '0 0 0 20px rgba(0, 0, 0, 0)',
      },
    },
  },
}));

export function Topbar() {
  useEffect(() => {
    const { pathname, search } = window.location;
    if (
      pathname.includes('my-profile') &&
      pathname.includes('edit') &&
      search.includes('chat=open')
    ) {
      document.body.classList.add(HELP_BAR_OPEN_CLASS);
    }
  }, []);

  const handleHelpSidebar = () => {
    document.body.classList.add(HELP_BAR_OPEN_CLASS);
  };

  const classes = useStyles();

  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(
        uiService.config,
        'extras.search.display'
      ),
      viewNotificationsDisplay: objectPath.get(
        uiService.config,
        'extras.notifications.display'
      ),
      viewQuickActionsDisplay: objectPath.get(
        uiService.config,
        'extras.quick-actions.display'
      ),
      viewCartDisplay: objectPath.get(uiService.config, 'extras.cart.display'),
      viewQuickPanelDisplay: objectPath.get(
        uiService.config,
        'extras.quick-panel.display'
      ),
      viewLanguagesDisplay: objectPath.get(
        uiService.config,
        'extras.languages.display'
      ),
      viewUserDisplay: objectPath.get(uiService.config, 'extras.user.display'),
    };
  }, [uiService]);

  return (
    <div className="topbar">
      <Button onClick={handleHelpSidebar}>
        <HelpIcon
          color={'disabled'}
          className={classes.pulse}
          style={{ borderRadius: '50%' }}
        />
      </Button>
      {layoutProps.viewUserDisplay && <QuickUserToggler />}
    </div>
  );
}
